import type {CrmOptionType} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../../../../analytics-client';
import {appHistory} from '../../../../../../history';

import {useGetImport2CrmOptions} from './use-get-import2-crm-options';
import {useInitiateImport} from './use-initiate-import2-import';

export function useGetCrmListData() {
    const {importInitiate, initiateError} = useInitiateImport();
    const onInitiateImport = (crmType: CrmOptionType, callback?: () => void) => {
        importInitiate({
            optionType: crmType,
        }).then((response) => {
            if (response && response.data && response.data.import2Initiate) {
                const originId = response.data.import2Initiate.originId;
                const isNewImport = response.data.import2Initiate.isNewImport;

                if (isNewImport) {
                    analyticsClient.track(analyticsClient.EVENTS.TRACK_IMPORT2_CRM_TYPE_SELECTED, {
                        crmType,
                    });
                }

                // Redirect to the status page for the import
                if (originId) {
                    appHistory.push(`/setup/import-import2/status/${originId}`);
                }

                // Callback to close the modal if it exists
                if (callback) {
                    callback();
                }
            }
        });
    };

    const {isLoading, crmOptions} = useGetImport2CrmOptions();

    return {
        isLoading,
        crmOptions: crmOptions || [],
        onInitiateImport,
        initiateError,
    };
}
